import { SmartTooltip } from '@sdk/common/tooltip/SmartTooltip';

import { Hoverable } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';
import NotesIconSvg from '@web/assets/svg/Icons/16/notes-gray.svg';

type Props = {
  consentDenyReason: string;
};

export const ConsentDeniedTooltip = ({ consentDenyReason }: Props) => {
  return (
    <SmartTooltip
      content={consentDenyReason}
      place="right"
      breakWord="break-all"
      offset={{ top: 2 }}
      minWidth={140}
      maxWidth={304}>
      <Hoverable>
        <NotesIconSvg />
      </Hoverable>
    </SmartTooltip>
  );
};
